/**
 * Persistência de mídias de follow-up em `media_url` (text):
 * - 1 URL → string simples (compatível com templates antigos)
 * - N URLs → JSON array
 *
 * Fonte única para Edge (`process-followups`) e app (`followUpMedia` reexporta).
 */

/** Lê `media_url` do banco (string ou JSON array) → lista de URLs. */
export function parseMediaUrls(raw: string | null | undefined): string[] {
  if (!raw) return [];
  const trimmed = raw.trim();
  if (!trimmed) return [];

  if (trimmed.startsWith('[')) {
    try {
      const parsed = JSON.parse(trimmed) as unknown;
      if (Array.isArray(parsed)) {
        return parsed.filter(
          (item): item is string => typeof item === 'string' && item.trim().length > 0,
        );
      }
    } catch {
      // fallback: trata como URL única
    }
  }

  return [trimmed];
}

/** Grava lista de URLs no formato do banco. */
export function serializeMediaUrls(urls: string[]): string | null {
  const clean = urls.map((u) => u.trim()).filter(Boolean);
  if (clean.length === 0) return null;
  if (clean.length === 1) return clean[0];
  return JSON.stringify(clean);
}
